import React from 'react';

const ServerError = ({ message = "An internal server error occurred. Please try again later." }) => {
    return (
        <div style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f2f2f2', color: '#333', borderRadius: '5px', boxShadow: '0 0 10px rgba(0,0,0,0.2)' }}>
            <h1 style={{ color: '#ff0000' }}>Server Error</h1>
            <p>{message}</p>
        </div>
    );
};

export default ServerError;

